module.exports = __webpack_public_path__ + "static/media/car_logo.68b10c2a.svg";